import { allTinggApplications, environment } from "./utils";
import platform from "platform";
import * as moment from "moment-timezone";
// Importing will automatically polyfill window.fetch and related APIs:
import "whatwg-fetch";

const { v4: uuidv4 } = require("uuid");

const regeneratorRuntime = require("regenerator-runtime");

export const initAuditLogs = (): void => {
  createDB();
  getUserLocation();
  captureAPICall();
  captureRouteChange();
  captureClicks();
  checkTimeCorrectness();
};

let request, database, notes;
let latitudeLongitude = null;
const lookupDataWorkerBlob = new Blob(
  [
    "(",
    function () {
      self.onmessage = (e) => {
        const workerParams = e?.data;

        if (!workerParams?.baseUrl) {
          const message = {
            success: false,
            data: "Missing parameters",
          };
          // @ts-ignore
          self.postMessage(message);
        }
        fetch(workerParams?.baseUrl, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          method: "post",
          body: JSON.stringify(workerParams.payload),
        })
          .then((response) =>
            response
              .json()
              .then((data) => ({ status: response.status, body: data }))
          )
          .then((data) => {
            let message;
            if (data.status == 400 || data.status == 200) {
              message = {
                success: true,
                data: data.body,
              };
            } else {
              message = {
                success: false,
                payload: workerParams.payload,
                baseUrl: workerParams?.baseUrl,
                retry: true,
              };
            }
            // @ts-ignore
            self.postMessage(message);
            // console.log(message, 'message');
          })
          .catch((err) => {
            const message = {
              success: false,
              payload: workerParams.payload,
              baseUrl: workerParams?.baseUrl,
              retry: true,
            };
            // @ts-ignore
            self.postMessage(message);
          });
      };
    }.toString(),
    ")()",
  ],
  { type: "application/javascript" }
);

let worker = null;
if (typeof Worker !== undefined) {
  worker = new Worker(URL.createObjectURL(lookupDataWorkerBlob));
  worker.onmessage = (e) => {
    if (e.data.retry) {
      onFailedRequest(e.data);
    } else {
      // iterateLogs();
    }
  };
}

const onFailedRequest = (data) => {
  addNote(data);
};

const sendLogToServer = async (data: any) => {
  // console.log('send to server -->', data.payload);
  // getGoogleAnalyticsCookie().then(l => console.log(l)).catch(err => err);

  // if(!data.payload['eventUUID']) {
  //   data.payload['eventUUID'] = await getGoogleAnalyticsCookie()
  //     .then(ga => ga)
  //     .catch(err => err);
  // }
  // if(!data.payload['systemUUID']){
  //   data.payload['systemUUID'] = uuidv4();
  // }

  // if (!data.payload["traceId"]) {
  //   data.payload["traceId"] =
  //     (await getGoogleAnalyticsCookie()) + " - " + uuidv4();
  // }

  if (typeof Worker !== undefined) {
    worker.postMessage(data);
  } else {
    fetch(data.baseUrl, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "post",
      body: JSON.stringify(data.payload),
    });
  }
};

const captureRouteChange = async () => {
  window.addEventListener("single-spa:routing-event", async (event) => {
    // let traceId = (await getGoogleAnalyticsCookie()) + " - " + uuidv4();
    let traceId = "";
    await getGoogleAnalyticsCookie()
      .then((data) => {
        traceId += data + " - " + uuidv4();
        // console.log(traceId);
      })
      .catch((err) => {
        traceId += err + " - " + uuidv4();
      });

    const detail = event["detail"];

    if (
      (detail.originalEvent &&
        detail.originalEvent.singleSpaTrigger == "pushState") ||
      (!detail.originalEvent?.hasOwnProperty("singleSpa") &&
        detail.originalEvent?.type == "popstate")
    ) {
      sendLogToServer({
        baseUrl: environment.auditLogApiUrl + "/data-access-event",
        payload: {
          ...fetchLoggedInUserData(),
          ...fetchDeviceData(),
          tenant: determineUserSelectedCountryCode(),
          eventType: "page-visit",
          description: "User page visit",
          status: "success",
          traceId,
        },
      });
    }
  });
};

export const captureFirstMount = async () => {
  // let traceId = (await getGoogleAnalyticsCookie()) + " - " + uuidv4();
  let traceId = "";
  await getGoogleAnalyticsCookie()
    .then((data) => {
      traceId += data + " - " + uuidv4();
      // console.log(traceId);
    })
    .catch((err) => {
      traceId += err + " - " + uuidv4();
    });
  sendLogToServer({
    baseUrl: environment.auditLogApiUrl + "/data-access-event",
    payload: {
      ...fetchLoggedInUserData(),
      ...fetchDeviceData(),
      tenant: determineUserSelectedCountryCode(),
      eventType: "page-visit",
      description: "User page visit",
      status: "success",
      traceId,
    },
  });
};

const captureAPICall = (): void => {
  const origXHR = window.XMLHttpRequest;
  // @ts-ignore
  window.XMLHttpRequest = () => {
    const xhr = new origXHR();
    xhr.open = (method: string, url: string) => {
      origXHR.prototype.open.call(xhr, method, url);
      let apiUrl = new URL(url);

      xhr.addEventListener("load", async (e) => {
        // let traceId = (await getGoogleAnalyticsCookie()) + " - " + uuidv4();
        let traceId = "";
        await getGoogleAnalyticsCookie()
          .then((data) => {
            traceId += data + " - " + uuidv4();
            // console.log(traceId);
          })
          .catch((err) => {
            traceId += err + " - " + uuidv4();
          });
        if (xhr.readyState == 4 && apiUrl.origin != "https://bam.nr-data.net") {
          if (xhr.responseURL.includes("/auth")) {
            return;
          }
          let status = "failed",
            descBuilder = "";

          if (xhr.status >= 200 && xhr.status <= 299) {
            status = "success";
            if (isValidJSON(xhr.response)) {
              let resp = JSON.parse(xhr.response);
              if (resp.statusCode != 200) {
                descBuilder += resp.message
                  ? ` returned status ${resp.statusCode} with message ${resp.message}`
                  : "";
              }
            }
          } else {
            try {
              let resp = JSON.parse(xhr.response);
              resp.message
                ? (descBuilder += ` failed with code ${resp["statusCode"]} and message ${resp["message"]}`)
                : (descBuilder += ` failed with code ${resp["errorCode"]} and message ${resp["errorMessage"]}`);
              descBuilder += "failed on load.";
            } catch (err) {
              descBuilder += ` failed with code ${xhr.status} and message ${xhr.statusText}`;
              descBuilder += "failed on load.";
            }
          }
          sendLogToServer({
            baseUrl: environment.auditLogApiUrl + "/data-access-event",
            payload: {
              ...fetchLoggedInUserData(),
              ...fetchDeviceData(),
              tenant: determineUserSelectedCountryCode(),
              eventType: "api-call",
              status: status,
              path: xhr.responseURL,
              description: "User API call" + descBuilder,
              traceId,
            },
          });
        }
      });
      xhr.addEventListener("error", async (e) => {
        if (url.includes("/auth")) {
          return;
        }
        // let traceId = (await getGoogleAnalyticsCookie()) + " - " + uuidv4();
        let traceId = "";
        await getGoogleAnalyticsCookie()
          .then((data) => {
            traceId += data + " - " + uuidv4();
            // console.log(traceId);
          })
          .catch((err) => {
            traceId += err + " - " + uuidv4();
          });
        if (apiUrl.origin != "https://bam.nr-data.net") {
          sendLogToServer({
            baseUrl: environment.auditLogApiUrl + "/data-access-event",
            payload: {
              ...fetchLoggedInUserData(),
              ...fetchDeviceData(),
              tenant: determineUserSelectedCountryCode(),
              eventType: "api-call",
              status: "failed",
              path: url,
              description: "User API call - failed in on error.",
              traceId,
            },
          });
        }
      });
    };
    return xhr;
  };
};

const captureClicks = () => {
  window.addEventListener("click", async ($event) => {
    // let traceId = (await getGoogleAnalyticsCookie()) + " - " + uuidv4();
    let traceId = "";
    await getGoogleAnalyticsCookie()
      .then((data) => {
        traceId += data + " - " + uuidv4();
        // console.log(traceId);
      })
      .catch((err) => {
        traceId += err + " - " + uuidv4();
      });
    let data = {
      ...fetchLoggedInUserData(),
      ...fetchDeviceData(),
      tenant: determineUserSelectedCountryCode(),
      status: "success",
      eventType: "click",
      traceId,
    };
    switch (($event.target as HTMLElement).nodeName) {
      case "BUTTON":
        const but = $event.target as HTMLButtonElement;
        // data["description"] =
        //   `${but.localName} - ${but.innerText} (${but['ariaLabel']})`;
        data[
          "description"
        ] = `${but.localName} - ${but.innerText} (${but.firstChild["innerText"]})`;
        data["description"] = data["description"] + " clicked";
        break;
      case "A":
        const a = $event.target as HTMLAnchorElement;
        data[
          "description"
        ] = `${a.localName} - ${a.innerText} clicked (${a.download})`;
        break;
      case "LI":
        const li = $event.target as HTMLLIElement;
        data["description"] = `${li.localName} - ${li.innerHTML} clicked`;
        break;
      case "INPUT":
        const input = $event.target as HTMLInputElement;
        data[
          "description"
        ] = `${input.localName} - ${input.placeholder} clicked`;
        break;
      case "SPAN":
        const span = $event.target as HTMLSpanElement;
        data["description"] = `${span.localName} - ${span.innerText} clicked`;
        break;
      default:
        break;
    }
    if (data["description"]) {
      sendLogToServer({
        baseUrl: environment.auditLogApiUrl + "/data-access-event",
        payload: {
          ...data,
        },
      });
    }
  });
};

const getCurrentAppCodeName = (): string => {
  const urlFirstPathName = window.location.pathname.split("/")[1];
  const currentUrl = "/" + urlFirstPathName;

  return (
    allTinggApplications.find((el) => el.activeWhen === currentUrl)?.codeName ||
    ""
  );
};

const fetchLoggedInUserData = () => {
  let userData = {
    path: decodeURIComponent(
      window.location.href.replace(window.location.origin, "")
    ),
    applicationName: getCurrentAppCodeName(),
  };
  const data = JSON.parse(localStorage.getItem("User"));
  if (data) {
    userData["userId"] = data?.sub;
    userData["userName"] = data?.username;
    userData["customerLevel"] = data?.customer?.customerLevelCode;
    userData["customerCode"] = data?.customer?.customerCode;
    userData["sessionID"] = data?.sessionID;
    userData["authRequestId"] = data?.oauthRequestID;
  }
  if (!userData["authRequestId"]) {
    const Oath = JSON.parse(localStorage.getItem("Oath"));
    if (Oath) {
      userData["authRequestId"] = Oath?.authorization_code;
    }
  }
  return userData;
};

const fetchDeviceData = () => {
  return {
    dateGenerated: new Date().toISOString(),
    device: platform.description,
    location: latitudeLongitude,
    source: "UI",
  };
};

const getUserLocation = (): void => {
  navigator.geolocation.getCurrentPosition((location) => {
    latitudeLongitude =
      location.coords.latitude + ", " + location.coords.longitude;
  });
};

const isMacintosh = (): boolean => {
  return navigator.platform.indexOf("Mac") > -1;
};

const isWindows = (): boolean => {
  return navigator.platform.indexOf("Win") > -1;
};

const createDB = () => {
  request = window.indexedDB.open("FailedLogsQueue", 1);

  request.onupgradeneeded = (e) => {
    database = (e.target as IDBOpenDBRequest).result;
    notes = database.createObjectStore("logs", { keyPath: "id" });
  };

  request.onsuccess = (e) => {
    database = (e.target as IDBOpenDBRequest).result;
  };

  request.onerror = (e) => {};
};

const addNote = (data): void => {
  const id = Date.now().toString(36);
  data["id"] = id;
  // data['retriedTimes'] ? data['retriedTimes']++ : data['retriedTimes'] = 0;
  // data.payload['retriedTimes'] = data.payload['retriedTimes'] ? +data.payload['retriedTimes']++ : 1;

  // const tx = database.transaction("logs", "readwrite");
  // const objStST = tx.objectStore("logs");
  // objStST.add(data);
};

let isIterating = false;
const iterateLogs = (): void => {
  if (!isIterating) {
    isIterating = true;

    const tx = database.transaction("logs", "readonly");
    const objStST = tx.objectStore("logs");
    const request = objStST.openCursor();

    request.onsuccess = (e) => {
      const cursor = (e.target as IDBRequest).result;
      if (cursor) {
        retry(cursor.value.payload);
        deleteLog(cursor.key);
        cursor.continue();
      } else {
        isIterating = false;
      }
    };
  }
};

const retry = (data) => {
  sendLogToServer({
    baseUrl: environment.auditLogApiUrl + "/data-access-event",
    payload: {
      ...data,
    },
  });
};

const deleteLog = (id): void => {
  const tx = database.transaction("logs", "readwrite");
  const objStor = tx.objectStore("logs");
  objStor.delete(id);
};

const checkTimeCorrectness = () => {
  const d = new Date();
  const userTimeBeforeCallAPI: any = new Date(
    d.getUTCFullYear(),
    d.getUTCMonth(),
    d.getUTCDate(),
    d.getUTCHours(),
    d.getUTCMinutes(),
    d.getUTCSeconds(),
    d.getUTCMilliseconds()
  );

  fetch(environment.timeApiUrl + "/current/zone?timeZone=Africa/Accra", {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    method: "get",
  })
    .then((r) => r.json())
    .then((json) => {
      const accraTime: any = new Date(json.dateTime);
      const difference = (accraTime - userTimeBeforeCallAPI) / 1000;

      const overlay: HTMLElement =
        window.document.querySelector(".incorrect-time");
      const windowsLink: HTMLElement = window.document.querySelector(
        "#link-windows-settings"
      );
      const macLink: HTMLElement =
        window.document.querySelector("#link-mac-settings");

      if (difference > 300 || difference < -300) {
        overlay.style.display = "flex";

        determineUserTime(json.dateTime + "Z");

        if (isWindows() && windowsLink) {
          windowsLink.style.display = "block";
        }
        if (isMacintosh() && macLink) {
          macLink.style.display = "block";
        }
      } else {
        overlay.style.display = "none";
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

const determineUserTime = (time) => {
  const userZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const zoneEl: HTMLElement = window.document.querySelector("#user-timezone");
  const timeEl: HTMLElement = window.document.querySelector("#user-time");
  zoneEl.innerText = userZone;

  setInterval(() => {
    time = moment.tz(time, userZone).add(1, "second");
    timeEl.innerText = time.format("hh:mm:ss A");
  }, 1000);
};

const getGoogleAnalyticsCookie = async () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      document.cookie.split(";").forEach((elem) => {
        if (elem.includes("_ga=GA")) {
          // console.log(elem.split('=')[1]);
          resolve(elem.split("=")[1]);
          return;
        }
      });
      reject("not found");
    }, 1000);
  });
};

const isValidJSON = (str): boolean => {
  try {
    return JSON.parse(str) && !!str;
  } catch (e) {
    return false;
  }
};

const determineUserSelectedCountryCode = (): string => {
  const data = JSON.parse(localStorage.getItem("UserSelectedCurrency") ?? "{}");
  if (data?.isoCode) {
    return data.isoCode;
  } else {
    return "";
  }
};
